export const mutations = {
  STORE_REQUISITIONS(state, requisitions) {
    state.requisitions = requisitions;
  },
  STORE_TRANSPORTER_TRUCKS(state, transportertrucks) {
    state.transportertrucks = transportertrucks;
  },
  STORE_TRANSPORTER(state, transporter) {
    state.transporter = transporter;
  },
  STORE_REQUISITION_UPDATE(state, requisitionId) {
    let Requisition = state.requisitions.find(function(requisition) {
      return requisition.id === requisitionId;
    });
    state.systemRequisition = Requisition;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/requisitions/mutations.js